import { render } from "./community.vue?vue&type=template&id=6dcb25c3&scoped=true"
const script = {}

import "./community.vue?vue&type=style&index=0&id=6dcb25c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dcb25c3"

export default script